import axios from 'axios';

export default {
  getPowerbiReportToken: (reportId, groupId) => {
    return axios.get(`/reports/token/powerbi`, {
      params: { reportId, groupId },
    });
  },
};
